import { EditorContent } from "@tiptap/react";
import { useMeasure } from "@uidotdev/usehooks";
import { useRouteContext } from "@tanstack/react-router";
import { useEditor } from "@/editor/editor";
import { graphql, useFragment } from "react-relay";
import type { postContentFragment$key } from "./__generated__/postContentFragment.graphql";

export function PostContent({ post }: { post: postContentFragment$key }) {
	const [editorRef] = useMeasure();
	const { club, session } = useRouteContext({ from: "__root__" });

	const data = useFragment<postContentFragment$key>(
		graphql`
      fragment postContentFragment on Post {
        content
      }
    `,
		post,
	);

	const editor = useEditor({
		editable: false,
		content: data.content,
		features: {
			placeholder: { enabled: true },
			colors: { enabled: true },
			attachments: { enabled: true },
			video: { enabled: true },
			poll: { enabled: true },
			youtube: { enabled: true },
			image: { enabled: true },
			iframe: { enabled: true },
			button: { enabled: true },
			mention: { enabled: true },
			styling: { enabled: true },
		},
		club: club?.id,
		session: session,
	});

	return (
		<div className="prose dark:prose-invert w-full min-w-full">
			{editor ? <EditorContent editor={editor} ref={editorRef} /> : null}
		</div>
	);
}
